import { Component, OnInit, OnDestroy } from '@angular/core';
import { PreparationsService } from 'src/app/services/catalogs-services/preparations-services/preparations.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { ActivatedRoute } from '@angular/router';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { PreparationBasic } from 'src/app/models/catalogs-model/preparation.model';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { HeaderBreadcrumbService } from '../../header-components/header-breadcrumb/header-breadcrumb.service';

@Component({
  selector: 'app-catalogs-preparation-dashboard',
  templateUrl: './catalogs-preparation-dashboard.component.html',
  styleUrls: ['./catalogs-preparation-dashboard.component.scss']
})
export class CatalogsPreparationDashboardComponent implements OnInit, OnDestroy {

  preparation: PreparationBasic;
  getPreparationInfoSubscription: Subscription;
  getPreparationInfoSubscriptionRefresh: Subscription;

  constructor(private preparationsService: PreparationsService,
              private snackbarService: SnackBarService,
              private headerBreadcrumbService: HeaderBreadcrumbService,
              private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.setBreadcrumb();
    this.getPreparationInfo();
    this.getPreparationInfoSubscriptionRefresh = this.preparationsService.refreshPreparationListen().subscribe(
      (res) => {
        this.getPreparationInfo();
      }
    );
  }

  private getPreparationInfo() {
    const internalId = this.activatedRoute.snapshot.params['preparationid'];
    this.getPreparationInfoSubscription = this.preparationsService.getPreparationInfo(internalId).subscribe(
      (res) => {
        this.preparation = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-cut', 'catalogs-page.preparation detail', '/catalog/preparations', [new BRoute('catalogs-page.catalog', '/catalog'), new BRoute('catalogs-page.preparations', '/catalog/preparations'), new BRoute('catalogs-page.preparation detail')]));
  }

  ngOnDestroy() {
    if (this.getPreparationInfoSubscription) { this.getPreparationInfoSubscription.unsubscribe(); }
    if (this.getPreparationInfoSubscriptionRefresh) { this.getPreparationInfoSubscriptionRefresh.unsubscribe(); }
  }
}
